import { NavButton } from "./components/navButton/navButton";
import { Slides } from "./components/slides/slides";
import { Base } from "./slider.base";

export const Slider = Object.assign(Base, {
    Slides: Slides,
    NavButton: NavButton
});
